export const columns = [
    {
        title: '商品图片', key: 'productImg', dataIndex: 'productImg', scopedSlots: {
            customRender: 'productImgAction'
        }
    },
    {title: '商品名称', key: 'productName', dataIndex: 'productName'},
    {title: '商品sku', key: 'shopProductSku', dataIndex: 'shopProductSku'},
    {
        title: '已装箱数量/总数量', key: 'amount', dataIndex: 'amount',
        scopedSlots: {
            customRender: 'amountAction'
        }
    },
    // {
    //   title: "批次包总数量",
    //   key: "pkgAmount",
    //   dataIndex: "pkgAmount"
    // }
    // {
    //     title: '托盘数量', key: 'inventoryAmount', dataIndex: 'inventoryAmount', scopedSlots: {
    //         customRender: 'action'
    //     }
    // },
]
